// extracted by mini-css-extract-plugin
module.exports =  {"container":"_02712f2b3b--container--fo3iO","chat-container":"_02712f2b3b--chat-container--hV4km","jump":"_02712f2b3b--jump--joYmu"};